import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("am_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const ASSETS = {
  hero: "/media/hero.webp",
  couplePortrait: "/media/couplePortrait.jpg",
  coupleKiss: "/media/coupleKiss.webp",
  coupleEmbrace: "/media/coupleEmbrace.jpg",
  coupleBouquet: "/media/coupleBouquet.jpg",
  coupleWalking: "/media/coupleWalking.webp",
  coupleChampagne: "/media/coupleChampagne.jpg",
  coupleFlorals: "/media/coupleFlorals.webp",
  coupleClose: "/media/coupleClose.webp",
  coupleSurprise: "/media/coupleSurprise.webp",
  coupleHall: "/media/coupleHall.webp",
  // Traditional attire studio portraits (silver/grey aso ebi)
  tradFacing: "/media/tradFacing.webp",
  tradEmbrace: "/media/tradEmbrace.webp",
  tradSeated: "/media/tradSeated.webp",
  videoTraditional: "/media/save-the-date-traditional.mp4",
  videoWhite: "/media/save-the-date-white.mp4",
};

export const GALLERY = [
  { src: "/media/coupleClose.webp", label: "Held Close", orientation: "portrait" },
  { src: "/media/coupleFlorals.webp", label: "The Moment", orientation: "portrait" },
  { src: "/media/coupleSurprise.webp", label: "The Roses", orientation: "portrait" },
  { src: "/media/coupleEmbrace.jpg", label: "The Embrace", orientation: "portrait" },
  { src: "/media/coupleHall.webp", label: "Twenty Steps", orientation: "portrait" },
  { src: "/media/coupleChampagne.jpg", label: "The Toast", orientation: "portrait" },
  { src: "/media/coupleBouquet.jpg", label: "The Bouquet", orientation: "landscape", featured: true },
];

export const WEDDING_DATE = new Date("2027-05-08T00:00:00");
